<template>
  <div class="front">
    <header>
      <div class="fiexdRegion">
        <!--▼▼ハンバーガーメニューここから▼▼-->
        <div id="nav-drawer">
          <input id="nav-input" type="checkbox" class="nav-unshown">
          <label id="nav-open" for="nav-input"><span></span></label>
          <label class="nav-unshown" id="nav-close" for="nav-input"></label>
          <div id="nav-content">
            <nav class="fixedNav-mobile">
              <ul>
                <li><a href="/"><img src="/static/front/min-logo.png"></a></li>
                <li><a href="/#concept">concept</a></li>
                <li><a href="/#service">easy to use</a></li>
                <li><a href="/artist">artist</a></li>
                <li><a href="/#news">news</a></li>
                <li><a href="/#contact">contact</a></li>
                <li><a href="#policy">policy</a></li>
                <li><a href="/login" target="_blank"><img src="/static/front/login.png"></a></li>
              </ul>
            </nav>
          </div>
        </div>
        <p class="log-mobile"><a href="/login" target="_blank"><img src="/static/front/login.png"></a></p>
        <!--▲▲ハンバーガーメニューここまで▲▲-->
      </div>
      <div id="mainTitle">
        <h1>ARTIST LINEUP</h1>
          <p class="main-p">
            各種メディアに取り上げられた実績のあるアーティストたちを擁し、およそ1300曲に及ぶ、クオリティの高い楽曲をご提供いたします。
          </p>
      </div>
      <nav class="fixedNav">
        <ul>
          <li><a href="/"><img src="/static/front/min-logo.png"></a></li>
          <li><a href="/#concept">concept</a></li>
          <li><a href="/#service">easy to use</a></li>
          <li><a href="/artist">artist</a></li>
          <li><a href="/#news">news</a></li>
          <li><a href="/#contact">contact</a></li>
          <li><a href="#policy">policy</a></li>
          <li><a href="/login" target="_blank"><img src="/static/front/login.png"></a></li>
        </ul>
      </nav>
      <p class="topLogin"><a href="/login" target="_blank"><img src="/static/front/login.png"></a></p>
    </header>

    <section>
      <div id="artist">
        <div class="artistWrap">
          <!--1組のアーティストここから-->
          <div class="artistBox" v-for="item in artist" :key="item.artist_id">
            <div class="flex-center artistColumn">
              <div>
                <p v-if="item.main_large_image != null" class="artistPhoto"><img :src="item.main_large_image"></p>
                <p v-else class="artistPhoto"><img src="/static/unknown.png"></p>
              </div>
              <div class="artistName">
                <p>{{ item.artist_name }}</p>
                <p>{{ item.profile }}</p>
                <!--<p>{{ item.artist_name_kana }}</p>-->
                <p>
                  <a v-if="item.link_homepage != null" v-bind:href="item.link_homepage" target="_blank">
                    <img src="/static/front/hp.png">
                  </a>
                  <a v-if="item.link_facebook != null" v-bind:href="item.link_facebook" target="_blank">
                    <img class="pl-10" src="/static/front/face.png">
                  </a>
                  <a v-if="item.link_twitter != null" v-bind:href="item.link_twitter" target="_blank">
                    <img class="pl-10" src="/static/front/twitter.png">
                  </a>
                  <a v-if="item.link_blog != null" v-bind:href="item.link_blog" target="_blank">
                    <img class="pl-10" src="/static/front/blog.png">
                  </a>
                </p>
              </div>
            </div>
            <!-- モーダル ここから-->
            <artist-profile
              :artistImg="item.main_large_image"
              :artistName="item.artist_name"
              :artistName_kana="item.artist_name_kana"
              :profile="item.main_list_comment"
              :career="item.main_comment"
              :hp="item.link_homepage"
              :facebook="item.link_facebook"
              :twitter="item.link_twitter"
              :blog="item.link_blog"
            />
            <!-- モーダル ここまで-->
          </div>
          <!--1組のアーティストここまで-->
        </div>
      </div>
    </section>

    <footer>
      <div class="footer-flex">
        <p class="footerLogo"><img src="/static/front/min-logo.png"></p>
      </div>
      <p class="has-text-centered"><small>©2018 ファイブイノベーション株式会社</small></p>
    </footer>
  </div>
</template>

<script>
import ArtistProfile from '@/components/ArtistProfile.vue'
import axios from 'axios'
export default {
  name: 'ArtistLP',
  components: {
    ArtistProfile
  },
  data () {
    return {
      artist: [],
      dialog: false
    }
  },
  mounted () {
    axios
      .get('https://withm.net/members/ajax/artist_list_lp.php')
      .then(response => (this.artist = response.data))
  }
}
</script>

<style scoped>
@import "../assets/style/front.scss";
</style>



// WEBPACK FOOTER //
// src/pages/ArtistLP.vue